// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"4":"eedc74e8","60":"0604fa0b","78":"ccc17ee6","338":"1bfcdc34","541":"c29f7af0","544":"e37887be","576":"53a19442","753":"37161b8a","775":"ea1b90ba","805":"408867d6","823":"37f6930c","949":"b733d70c","990":"592602a2"}[chunkId] + ".js";
};